var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6424A9F732E3235551Bbc201CustomerFirstIconDarkstudioXWebflowTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4330_17853)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.7463,
    cy: 14.5358,
    rx: 14.5363,
    ry: 14.5363,
    fill: "#FF7020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.918 54.2392C39.6806 54.2392 50.8374 43.0824 50.8374 29.3198C50.8374 15.5572 39.6806 4.40039 25.918 4.40039C12.1553 4.40039 0.998535 15.5572 0.998535 29.3198C0.998535 43.0824 12.1553 54.2392 25.918 54.2392Z",
    stroke: "white",
    strokeWidth: 1.55746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.918 37.626C31.6524 37.626 36.3011 32.9774 36.3011 27.243C36.3011 21.5085 31.6524 16.8599 25.918 16.8599C20.1836 16.8599 15.5349 21.5085 15.5349 27.243C15.5349 32.9774 20.1836 37.626 25.918 37.626Z",
    stroke: "white",
    strokeWidth: 1.55746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25293 47.853C10.8154 44.7755 13.1994 42.1907 16.1409 40.3852C19.0824 38.5797 22.4664 37.624 25.9178 37.624C29.3692 37.624 32.7532 38.5797 35.6947 40.3852C38.6362 42.1907 41.0202 44.7755 42.5827 47.853",
    stroke: "white",
    strokeWidth: 1.55746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4330_17853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6424A9F732E3235551Bbc201CustomerFirstIconDarkstudioXWebflowTemplate);
export default __webpack_public_path__ + "static/media/6424a9f732e3235551bbc201_customer-first-icon-darkstudio-x-webflow-template.f27858a161688df373108dcdeb0bc5da.svg";
export { ForwardRef as ReactComponent };